var map = {
	"./acme-corp.png": "e63c",
	"./contratei.png": "5afd",
	"./erro404.png": "90ca",
	"./logo-tech.png": "72b8",
	"./logo_fleury.png": "7bcb",
	"./salus.png": "34ca",
	"./salus_black.png": "b06b",
	"./salus_white.png": "30d0",
	"./sem-uso.png": "c6b7",
	"./tec.png": "ea3b",
	"./technoPlus.png": "23d8",
	"./wonka_logo.png": "d780"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7338";